/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Showcase_Title_LeadInputs */

const en_features_showcase_title_lead = /** @type {(inputs: Features_Showcase_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You train.`)
};

const pl_features_showcase_title_lead = /** @type {(inputs: Features_Showcase_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ty trenujesz.`)
};

/**
* | output |
* | --- |
* | "You train." |
*
* @param {Features_Showcase_Title_LeadInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_showcase_title_lead = /** @type {((inputs?: Features_Showcase_Title_LeadInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Showcase_Title_LeadInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_showcase_title_lead(inputs)
	return en_features_showcase_title_lead(inputs)
});